import { Component, Input } from '@angular/core';
import { OmpImageRatio } from '../../../_models';
import { OmpImageRatioOptions } from '../../order-management-portal.sections';
import { ompDesktopImageWidth, ompImageSizeHint, ompMobileImageWidth, OmpSectionSettings } from '..';

@Component({
  selector: 'omp-image-banner-settings',
  templateUrl: './image-banner-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpImageBannerSettingsComponent extends OmpSectionSettings {
  public imageRatioOptions = OmpImageRatioOptions;

  @Input() contentWidth = 700;
  @Input() horizontalPadding = 32;
  @Input() columnCount = 1;

  get desktopHint(): string {
    const width = ompDesktopImageWidth({
      contentWidth: this.contentWidth,
      horizontalPadding: this.horizontalPadding,
      columnCount: this.columnCount,
    });
    return ompImageSizeHint(width, this.ratio);
  }

  get mobileHint(): string {
    return ompImageSizeHint(ompMobileImageWidth(), this.ratio);
  }

  private get ratio(): string {
    return this.data ? this.data.image_ratio : OmpImageRatio.Adapt;
  }
}
